/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiLanguageV1Id$Json } from '../fn/language/delete-api-language-v-1-id-json';
import { DeleteApiLanguageV1Id$Json$Params } from '../fn/language/delete-api-language-v-1-id-json';
import { deleteApiLanguageV1Id$Plain } from '../fn/language/delete-api-language-v-1-id-plain';
import { DeleteApiLanguageV1Id$Plain$Params } from '../fn/language/delete-api-language-v-1-id-plain';
import { getApiLanguageV1$Json } from '../fn/language/get-api-language-v-1-json';
import { GetApiLanguageV1$Json$Params } from '../fn/language/get-api-language-v-1-json';
import { getApiLanguageV1$Plain } from '../fn/language/get-api-language-v-1-plain';
import { GetApiLanguageV1$Plain$Params } from '../fn/language/get-api-language-v-1-plain';
import { getApiLanguageV1Id$Json } from '../fn/language/get-api-language-v-1-id-json';
import { GetApiLanguageV1Id$Json$Params } from '../fn/language/get-api-language-v-1-id-json';
import { getApiLanguageV1Id$Plain } from '../fn/language/get-api-language-v-1-id-plain';
import { GetApiLanguageV1Id$Plain$Params } from '../fn/language/get-api-language-v-1-id-plain';
import { LanguageInputModel } from '../models/language-input-model';
import { LanguageModel } from '../models/language-model';
import { postApiLanguageV1$Json } from '../fn/language/post-api-language-v-1-json';
import { PostApiLanguageV1$Json$Params } from '../fn/language/post-api-language-v-1-json';
import { postApiLanguageV1$Plain } from '../fn/language/post-api-language-v-1-plain';
import { PostApiLanguageV1$Plain$Params } from '../fn/language/post-api-language-v-1-plain';
import { postApiLanguageV1Create$Json } from '../fn/language/post-api-language-v-1-create-json';
import { PostApiLanguageV1Create$Json$Params } from '../fn/language/post-api-language-v-1-create-json';
import { postApiLanguageV1Create$Plain } from '../fn/language/post-api-language-v-1-create-plain';
import { PostApiLanguageV1Create$Plain$Params } from '../fn/language/post-api-language-v-1-create-plain';
import { putApiLanguageV1Id$Json } from '../fn/language/put-api-language-v-1-id-json';
import { PutApiLanguageV1Id$Json$Params } from '../fn/language/put-api-language-v-1-id-json';
import { putApiLanguageV1Id$Plain } from '../fn/language/put-api-language-v-1-id-plain';
import { PutApiLanguageV1Id$Plain$Params } from '../fn/language/put-api-language-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class LanguageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiLanguageV1()` */
  static readonly GetApiLanguageV1Path = '/private/v1/languages';

  /**
   * Retrieve the list all the existing languages available the database asynchronously (parameter).
   *
   * Retrieve the list all of the existing languages from the database asynchronously (parameter)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiLanguageV1$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1$Plain$Response(params?: GetApiLanguageV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return getApiLanguageV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all the existing languages available the database asynchronously (parameter).
   *
   * Retrieve the list all of the existing languages from the database asynchronously (parameter)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiLanguageV1$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1$Plain(params?: GetApiLanguageV1$Plain$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.getApiLanguageV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /**
   * Retrieve the list all the existing languages available the database asynchronously (parameter).
   *
   * Retrieve the list all of the existing languages from the database asynchronously (parameter)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiLanguageV1$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1$Json$Response(params?: GetApiLanguageV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return getApiLanguageV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all the existing languages available the database asynchronously (parameter).
   *
   * Retrieve the list all of the existing languages from the database asynchronously (parameter)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiLanguageV1$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1$Json(params?: GetApiLanguageV1$Json$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.getApiLanguageV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /** Path part for operation `postApiLanguageV1()` */
  static readonly PostApiLanguageV1Path = '/private/v1/languages';

  /**
   * Retrieve the list all of the existing languages from the database asynchronously.
   *
   * Retrieve the list all of the existing languages from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiLanguageV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1$Plain$Response(params?: PostApiLanguageV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return postApiLanguageV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all of the existing languages from the database asynchronously.
   *
   * Retrieve the list all of the existing languages from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiLanguageV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1$Plain(params?: PostApiLanguageV1$Plain$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.postApiLanguageV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /**
   * Retrieve the list all of the existing languages from the database asynchronously.
   *
   * Retrieve the list all of the existing languages from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiLanguageV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1$Json$Response(params?: PostApiLanguageV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return postApiLanguageV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all of the existing languages from the database asynchronously.
   *
   * Retrieve the list all of the existing languages from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiLanguageV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1$Json(params?: PostApiLanguageV1$Json$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.postApiLanguageV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /** Path part for operation `getApiLanguageV1Id()` */
  static readonly GetApiLanguageV1IdPath = '/private/v1/languages/{id}';

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiLanguageV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1Id$Plain$Response(params: GetApiLanguageV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return getApiLanguageV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiLanguageV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1Id$Plain(params: GetApiLanguageV1Id$Plain$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.getApiLanguageV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiLanguageV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1Id$Json$Response(params: GetApiLanguageV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return getApiLanguageV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiLanguageV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiLanguageV1Id$Json(params: GetApiLanguageV1Id$Json$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.getApiLanguageV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /** Path part for operation `putApiLanguageV1Id()` */
  static readonly PutApiLanguageV1IdPath = '/private/v1/languages/{id}';

  /**
   * Updates an existing Language Description by ID.
   *
   * Updates an existing Language Description by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiLanguageV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiLanguageV1Id$Plain$Response(params: PutApiLanguageV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return putApiLanguageV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Language Description by ID.
   *
   * Updates an existing Language Description by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiLanguageV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiLanguageV1Id$Plain(params: PutApiLanguageV1Id$Plain$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.putApiLanguageV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /**
   * Updates an existing Language Description by ID.
   *
   * Updates an existing Language Description by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiLanguageV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiLanguageV1Id$Json$Response(params: PutApiLanguageV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageModel>>> {
    return putApiLanguageV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Language Description by ID.
   *
   * Updates an existing Language Description by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiLanguageV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiLanguageV1Id$Json(params: PutApiLanguageV1Id$Json$Params, context?: HttpContext): Observable<Array<LanguageModel>> {
    return this.putApiLanguageV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageModel>>): Array<LanguageModel> => r.body)
    );
  }

  /** Path part for operation `deleteApiLanguageV1Id()` */
  static readonly DeleteApiLanguageV1IdPath = '/private/v1/languages/{id}';

  /**
   * Deletes a Language by ID.
   *
   * Deletes a Language by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiLanguageV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiLanguageV1Id$Plain$Response(params: DeleteApiLanguageV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageModel>> {
    return deleteApiLanguageV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Language by ID.
   *
   * Deletes a Language by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiLanguageV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiLanguageV1Id$Plain(params: DeleteApiLanguageV1Id$Plain$Params, context?: HttpContext): Observable<LanguageModel> {
    return this.deleteApiLanguageV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<LanguageModel>): LanguageModel => r.body)
    );
  }

  /**
   * Deletes a Language by ID.
   *
   * Deletes a Language by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiLanguageV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiLanguageV1Id$Json$Response(params: DeleteApiLanguageV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageModel>> {
    return deleteApiLanguageV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Language by ID.
   *
   * Deletes a Language by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiLanguageV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiLanguageV1Id$Json(params: DeleteApiLanguageV1Id$Json$Params, context?: HttpContext): Observable<LanguageModel> {
    return this.deleteApiLanguageV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LanguageModel>): LanguageModel => r.body)
    );
  }

  /** Path part for operation `postApiLanguageV1Create()` */
  static readonly PostApiLanguageV1CreatePath = '/private/v1/languages/Create';

  /**
   * Creates a new Language.
   *
   * Creates a new Language.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiLanguageV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1Create$Plain$Response(params?: PostApiLanguageV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageInputModel>> {
    return postApiLanguageV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Language.
   *
   * Creates a new Language.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiLanguageV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1Create$Plain(params?: PostApiLanguageV1Create$Plain$Params, context?: HttpContext): Observable<LanguageInputModel> {
    return this.postApiLanguageV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<LanguageInputModel>): LanguageInputModel => r.body)
    );
  }

  /**
   * Creates a new Language.
   *
   * Creates a new Language.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiLanguageV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1Create$Json$Response(params?: PostApiLanguageV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageInputModel>> {
    return postApiLanguageV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Language.
   *
   * Creates a new Language.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiLanguageV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiLanguageV1Create$Json(params?: PostApiLanguageV1Create$Json$Params, context?: HttpContext): Observable<LanguageInputModel> {
    return this.postApiLanguageV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LanguageInputModel>): LanguageInputModel => r.body)
    );
  }

}
